<template>
  <div id="ticketing-step-2" v-if="step === 2">
    <div class="ticketing-content">
      <div class="card">
        <div class="card-header bg-light">
          <div class="card-header-title text-muted">
            Tóm tắt đơn hàng
          </div>
        </div>
        <div class="table-responsive">
          <table class="table card-table">
            <thead>
            <tr>
              <th>Mô tả</th>
              <th class="text-center">Số lượng</th>
              <th class="text-right">Thành tiền</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="product in cart.products" :key="product.id">
              <td>{{ product.name }}</td>
              <td class="text-center">{{ product.quantity }}</td>
              <td class="text-right">{{ useFormatting().formatCurrency(product.price * product.quantity) }}</td>
            </tr>
            <tr>
              <td colspan="2">Phí tiện ích</td>
              <td class="text-right">{{ useFormatting().formatCurrency(amount.fee) }}</td>
            </tr>
            <tr>
              <td colspan="2">Tổng</td>
              <td class="text-right">{{ useFormatting().formatCurrency(amount.total) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <contact-form
        :contact="form.contact"
        :violations="violations"
        @update:contact="form.contact = $event"
      />

      <payment-method-form
        :payment="form.payment"
        :user="user"
        :amount="amount"
        :show-apple-pay="false"
        bank-transfer-description="Tự động xuất mã voucher trong 30s sau khi chuyển khoản"
        @update:payment="form.payment = $event"
        @open:modal="emit('open:modal', $event)"
      />
    </div>
  </div>

  <div class="modal fade" id="moveekCreditsModal" role="dialog" v-if="user.authenticated">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="card mb-0">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="card-header-title">
                  Moveek Credits
                </h4>
              </div>
              <div class="col-auto">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="alert alert-light text-center">
              <a :href="root.url('orn_web_user_credits')" class="h1 font-thin block">{{ useFormatting().formatCurrency(user.balance) }}</a>
              <span class="text-muted text-small d-block">Số dư</span>
            </div>

            <p>Số dư tài khoản <strong>Moveek Credits</strong> của bạn
              không đủ để thanh toán cho đơn hàng này.</p>

            <p class="mb-0">Hãy <a :href="root.url('orn_web_user_deposit')" target="_blank">nạp thêm</a> hoặc tiếp tục thanh toán bằng các hình thức khác.</p>
          </div>
          <div class="card-footer">
            <a class="btn btn-dark" :href="root.url('orn_web_user_deposit')" target="_blank">Nạp thêm</a>
            <button type="button" class="btn btn-light float-right" data-dismiss="modal" aria-label="Close">Đóng</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="orderConfirmationModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="card mb-0">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="card-header-title">
                  Xác nhận đơn hàng
                </h4>
              </div>
              <div class="col-auto">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="cart.products.length > 0">
            <ul class="list-group list-group-flush list mb-3">
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Rạp</div>
                  <div class="col">Lotte Cinema</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Phim</div>
                  <div class="col">Các phim đang chiếu</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Suất</div>
                  <div class="col">Các suất 2D (bao gồm cuối tuần, lễ, Tết)</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Ghế</div>
                  <div class="col">Ghế 2D (bao gồm cả ghế VIP)</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Ngày hết hạn</div>
                  <div class="col">{{ useFormatting().formatDate(cart.products[0]?.expiredDate) }}</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Thông tin<br />cá nhân</div>
                  <div class="col">
                    {{ form.contact.name }}<br />
                    {{ form.contact.phone }}<br />
                    {{ form.contact.email }}
                  </div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Phương thức<br />thanh toán</div>
                  <div class="col">{{ useFormatting().formatPaymentMethod(form.payment.gateway, form.payment.method) }}</div>
                </div>
              </li>
            </ul>

            <a
                href="#"
                class="btn btn-lg btn-danger btn-block"
                :class="{ disabled: completing }"
                @click.prevent="emit('create:booking')"
            >
              {{ completing
                ? 'Đang xử lý, vui lòng chờ trong ít phút'
                : 'Tiến hành thanh toán'
              }}

            </a>

            <div class="alert alert-danger mt-4 mb-0" v-if="errors.length > 0">
              <p><strong>Có lỗi xảy ra</strong></p>
              <p class="mb-0" v-for="error in errors" :key="error" v-html="error"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { useFormatting } from '../composables/formatting';
import { inject, ref, watch } from 'vue';
import ContactForm from './ContactForm.vue';
import PaymentMethodForm from "./PaymentMethodForm.vue";

const props = defineProps({
  cart: {
    type: Object,
    required: true
  },
  user: {
    type: Object,
    required: true
  },
  step: {
    type: Number,
    required: true
  },
  contact: {
    type: Object,
    required: true,
    default: () => ({
      name: null,
      phone: null,
      email: null
    })
  },
  payment: {
    type: Object,
    required: true,
    default: () => ({
      gateway: 'moveek',
      method: 'bank-transfer',
    })
  },
  amount: {
    type: Object,
    required: true,
  },
  violations: {
    type: Array,
    required: true,
    default: []
  },
  errors: {
    type: Array,
    required: true,
    default: []
  },
  completing: {
    type: Boolean,
    required: true,
    default: false
  },
})

const emit = defineEmits([
  'update:contact',
  'update:payment',
  'create:booking',
  'open:modal',
])

const root = inject('root')

const form = ref({
  contact: props.contact,
  payment: props.payment,
})

const selectPayment = (gateway, method) => {
  // disable moveek credits if balance is insufficient
  if (gateway === 'moveek'
      && method === 'moveek-credits'
      && props.user.authenticated
      && props.user.balance < props.amount.total) {
    resetPayment()
    emit('open:modal', 'moveekCreditsModal')

    return
  }

  form.value.payment.gateway = gateway
  form.value.payment.method = method
}

const resetPayment = () => {
  form.value.payment.gateway = 'moveek'
  form.value.payment.method = 'bank-transfer'
}

// watch order changes
watch(props.amount, () => {
  // disable moveek credits if balance is insufficient
  if (form.value.payment.gateway === 'moveek'
      && form.value.payment.method === 'moveek-credits'
      && props.user.authenticated
      && props.user.balance < props.amount.total) {
    resetPayment()
  }
})

// whenever the prop changes, update the local copy
watch(() => props.contact, (value) => {
  form.value.contact = value
}, { deep: true })

watch(() => props.payment, (value) => {
  form.value.payment = value
}, { deep: true })

// whenever the local copy changes, tell the parent
watch(() => form.value.contact, (value) => {
  emit('update:contact', value)
}, { deep: true })

watch(() => form.value.payment, (value) => {
  emit('update:payment', value)
}, { deep: true })
</script>

<style scoped>
.required:before {
  content: "* ";
  color: #dc3545;
}
</style>